/**
 * Classify upload errors by HTTP status code with fallback to response body parsing
 * @param {number} code HTTP status code
 * @param {string} body Response body (usually JSON)
 * @returns {string} User-friendly error message
 */
export function classifyUploadError(code, body) {
    // Map HTTP status codes to user-friendly messages
    const STATUS_LABELS = {
        0: 'Network Connection Error',
        401: 'Session Expired - Please Refresh',
        403: 'Not Authorised',
        413: 'File Too Large',
        415: 'File Type Not Supported',
        422: 'Validation Error',
        429: 'Too Many Requests',
    }

    // Return mapped status message if available and not null
    if (Object.prototype.hasOwnProperty.call(STATUS_LABELS, code)) {
        return STATUS_LABELS[code]
    }

    // Handle server errors (5xx) and any unhandled errors
    return 'Server Error'
}

/**
 * Parse response body for inline FilePond file-item label
 * (when HTTP status code is not available)
 * @param {string} response Response body
 * @returns {string} User-friendly error message
 */
export function parseUploadResponseError(response) {
    if (!response || !response.trim()) {
        return 'Network Connection Error'
    }

    try {
        const parsed = JSON.parse(response)
        if (parsed?.message)
            return parsed.message
    } catch { }
    return 'Error during upload'
}